<template lang="pug">
.row.heatmap-header-row(:style="rowStyle")
  .col-auto
    h3.card-title.heatmap-header__item
      toggle-button(:value="$store.state[this.state_name].show_scroll_heatmap",:labels="{checked: 'スクロール', unchecked: 'スクロール'}", @change="toggleScroll", :sync="true", :width="85")
      help-tooltip(html-key='heatmapScroll')
  .col-auto
    h3.card-title.heatmap-header__item
      toggle-button(:value="$store.state[this.state_name].show_click_heatmap",:labels="{checked: 'クリック', unchecked: 'クリック'}", @change="toggleClick", :sync="true", :width="80")
      help-tooltip(html-key='heatmapClick')
  .col-auto
    h3.card-title.heatmap-header__item
      toggle-button(:value="$store.state[this.state_name].show_attention_heatmap",:labels="{checked: 'アテンション', unchecked: 'アテンション'}", @change="toggleAttention", :sync="true", :width="100")
      help-tooltip(html-key='heatmapAttention')
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props:{
    state_name: {
      type: String,
      default: "heatmap"
    },
    image_mode: {
      type: Boolean,
      default: false
    },
    is_multi_display: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    rowStyle() {
      return { display: "flex", justifyContent: "start" }
    },
  },
  data() {
    return {
    }
  },
  methods: {
    toggleScroll(e){
      this.$store.commit( `${this.state_name}/setShowScrollHeatmap`, e.value )
    },
    toggleClick(e){
      this.$store.commit( `${this.state_name}/setShowClickHeatmap`, e.value )
    },
    toggleAttention(e){
      this.$store.commit( `${this.state_name}/setShowAttentionHeatmap`, e.value )
    },
  },
  async mounted(){
    await Vue.nextTick()

  },
}
</script>

<style lang="scss" scoped>
.heatmap-header-row {
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}

.heatmap-header__item {
  display: flex;
  align-items: center;
  float: none;
  margin: 0;
  line-height: 0;

  ::v-deep .vue-js-switch {
    margin: 0;
    vertical-align: middle;
  }

  .help-tooltip {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    height: 22px;
    margin: 0 0 0 6px;
    line-height: 0;
  }
}
</style>
